import { Grid } from '@mui/material';
import { RoutalLoader, VSpacer } from '@nx-smartmonkey/ui';

import Text from '../../react-components/Text';

interface UploadDataProps {
  loading?: boolean;
  error?: boolean;
}

export const UploadData = ({ loading, error }: UploadDataProps) => {
  return (
    <Grid container style={{ width: `100%` }} alignItems={`center`} justifyContent={`center`}>
      {loading && (
        <Grid container alignItems={`center`} flexDirection={`column`}>
          <RoutalLoader />
          <VSpacer small />
          <Text variant="label" intlId={`data_importer_dialog.upload_data.loading.text`} />
        </Grid>
      )}
      {error && (
        <Grid container alignItems={`center`} flexDirection={`column`}>
          <Text variant="h5" intlId={`data_importer_dialog.upload_data.unknown_error.title`} />
          <VSpacer small />
          <Text intlId={`data_importer_dialog.upload_data.unknown_error.text`} />
          {/* <VSpacer small />
          <Text variant="label">{error}</Text> */}
        </Grid>
      )}
    </Grid>
  );
};
